module.exports = __webpack_public_path__ + "img/tutorial-pc-page1.76ea0a45.png";